import { Layout } from 'antd';
import type { PropsWithChildren } from 'react';

import { ReduxProvider } from '@/components/redux-provider';
import { ScopeHeadersProvider } from '@/components/scope-headers-provider';
import { useSidebarContext } from '@/contexts/sidebar-context';

import { TenantNavbar } from './tenant-navbar';
import { TenantSidebar } from './tenant-sidebar';

const { Content } = Layout;

function LayoutContent({ children }: PropsWithChildren) {
  const { desktop } = useSidebarContext();

  return (
    <Layout>
      <TenantSidebar />

      <Layout
        style={{
          marginLeft: desktop.isCollapsed ? 64 : 256,
          transition: 'margin-left 0.2s',
        }}
      >
        <Content
          style={{
            paddingTop: 64,
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          <div className="p-6">{children}</div>
        </Content>
      </Layout>
    </Layout>
  );
}

export function TenantLayoutWrapper({ children }: PropsWithChildren) {
  return (
    <ReduxProvider>
      <ScopeHeadersProvider>
        <Layout className="min-h-screen">
          <TenantNavbar />
          <LayoutContent>{children}</LayoutContent>
        </Layout>
      </ScopeHeadersProvider>
    </ReduxProvider>
  );
}
